import React from 'react';
import { useSelector } from 'react-redux';
import ProfileSetting from './pages/Profile/containers/ProfileSetting';

import { SideBarTypes } from './constants';
import { getSideBarType, getIsOpen } from './store/sidebar';

import SenderIdApplyForm from './pages/channels/SMS/containers/senderIdApplyForm';
import SenderIdEditForm from './pages/channels/SMS/containers/senderIdEditForm';
import senderIdView from './pages/channels/SMS/containers/senderIdView';
import contactsForm from './pages/Directory/containers/contactsForm';
import addTemplateForm from './pages/channels/Whatsapp/containers/addTemplateForm';
import editTemplateForm from './pages/channels/Whatsapp/containers/editTemplateForm';
import viewTemplateDetails from './pages/channels/Whatsapp/containers/viewTemplateDetails';
import Sandbox from './pages/channels/Whatsapp/containers/sandbox';
import performLookup from './pages/Directory/containers/performLookup';
import viewContact from './pages/Directory/containers/viewContact';
import contactsImport from './pages/Directory/containers/import';
import tagsForm from './pages/Directory/containers/tagsForm';
import NumbersForm from './pages/channels/Whatsapp/containers/NumbersForm';
import TemplateApplyForm from './pages/channels/SMS/containers/templateApplyForm';
import TemplateEditForm from './pages/channels/SMS/containers/templateEditForm';
import TemplateView from './pages/channels/SMS/containers/templateView';
import URLShortenerForm from './pages/urlShortener/containers/urlShortenerForm';
import APIKeyCreate from './pages/Developers/ApiKeys/containers/APIKeyCreate';
import APIKeyEdit from './pages/Developers/ApiKeys/containers/APIKeyEdit';
import APIKeyCreateSuccess from './pages/Developers/ApiKeys/containers/APIKeyCreateSuccess';
import FilterModal from './pages/CallbackProfiles/containers/FilterModal';
import CallbackProfileCreate from './pages/CallbackProfiles/containers/CallbackProfileCreate'
import FlowBuilderFilterModal from './pages/flowBuilder/ConsolidatedLogs/containers/FilterModal'
import StickyAgentModal from './pages/StickyAgents/containers/stickyAgentsModal';
import RequestReport from './pages/channels/SMS/containers/requestReport';
import WhatsappRequestReport from './pages/channels/Whatsapp/containers/requestReport';
import NumbersEditForm from './pages/channels/Whatsapp/containers/NumbersEditForm';
import verifiedSMSView from './pages/channels/SMS/containers/verifiedSMSView';
import PayloadModal from './pages/flowBuilder/StepwiseLogs/containers/PayloadModal';
import ViewSound from "./pages/Campaigns/SoundManager/container/ViewSound";
import SelectTemplate from './pages/channels/SMS/containers/receive-message/selectTemplate';
import ConfigurationEditForm from './pages/channels/SMS/containers/receive-message/editConfigurationForm';
import RechargeSubAccount from './pages/SubAccountsManagement/SubAccounts/containers/rechargeSubAccount'
import GenerateReports from './pages/SubAccountsManagement/Reports/containers/generateReports'
import BulkUrlShortnerForm from './pages/urlShortener/containers/bulkUrlShortenerForm';
import BulkEditForm from './pages/urlShortener/containers/bulkEditForm';
import AddUserGroupModal from "./pages/Campaigns/SipUserGroup/UserGroup/containers/AddUserGroupModal";
import AddSipAclModal from "./pages/Campaigns/SipACL/containers/AddSipAclModal";
import EditCredentialModal from "./pages/Campaigns/SipUserGroup/Credential/containers/EditCredentialModal";
import ChangeCredentialPasswordModal
	from "./pages/Campaigns/SipUserGroup/Credential/containers/ChangeCredentialPasswordModal";
import RenameUserGroupModal from "./pages/Campaigns/SipUserGroup/Credential/containers/RenameUserGroupModal";
import AddEditDomainModal from "./pages/Campaigns/SipDomain/containers/AddEditDomainModal";
import RenameSipAclModal from "./pages/Campaigns/SipIP/containers/RenameACL";
import SelectUrl from './pages/channels/SMS/containers/receive-message/selectUrl';

import VoicemailViewRecording from './pages/voicemail/containers/ViewRecording';
import VoicemailFilterModal from './pages/voicemail/containers/FilterModal';
import WhatsappTemplatesList from './pages/failover/containers/whatsappTemplatesList';
import CreateFailoverTemplates from './pages/failover/containers/createFailoverTemplates';
import EmailTemplates from './pages/failover/containers/emailTemplates';
import VoiceTemplates from './pages/failover/containers/voiceTemplates';
import SmsTemplates from './pages/failover/containers/smsTemplates';
import NewConfiguration from './pages/SubAccountsManagement/AutomatedReports/containers/newConfiguration';
import SpeechLogsFilterModal from './pages/Campaigns/SpeechLogs/containers/FilterModal';
import NewIpConfiguration from './pages/Developers/IpConfiguration/containers/newConfiguration';
import EditIpConfiguration from './pages/Developers/IpConfiguration/containers/editConfiguration';
import ViewApiKey from './pages/Developers/ApiKeys/containers/ViewApiKey';
import LowBalanceAlertConfig from './pages/SettingsV2/Notifications/containers/LowBalanceAlertConfig';
import ReportAlertConfig from './pages/SettingsV2/Notifications/containers/ReportAlertConfig';
import BillingAlertConfig from './pages/SettingsV2/Notifications/containers/BillingAlertConfig';
import AddEditIpConfig from './pages/SettingsV2/Security/containers/addOrEditIpConfig';
import EmailRequestReport from './pages/channels/Email/containers/requestReport';
import EditExpiryModal from './pages/urlShortener/containers/editExpiryModal';
import CallbackLogs from './pages/CallbackLogs/containers/CallbackLogs';
import CallbackLogsFilterModal from './pages/CallbackLogs/containers/filterModal';

const SideBars: Record<SideBarTypes, any> = {
	[SideBarTypes.senderIdApplyForm]: SenderIdApplyForm,
	[SideBarTypes.senderIdEditForm]: SenderIdEditForm,
	[SideBarTypes.senderIdView]: senderIdView,
	[SideBarTypes.lookup]: performLookup,
	[SideBarTypes.viewContact]: viewContact,
	[SideBarTypes.contactsForm]: contactsForm,
	[SideBarTypes.contactsImport]: contactsImport,
	[SideBarTypes.tagsForm]: tagsForm,
	[SideBarTypes.addWhatsappTemplate]: addTemplateForm,
	[SideBarTypes.viewWhatsapptemplate]: viewTemplateDetails,
	[SideBarTypes.editWhatsapptemplate]: editTemplateForm,
	[SideBarTypes.sandbox]: Sandbox,
	[SideBarTypes.wappNumbersForm]: NumbersForm,
	[SideBarTypes.wappNumbersEditForm]: NumbersEditForm,
	[SideBarTypes.templateApplyForm]: TemplateApplyForm,
	[SideBarTypes.templateEditForm]: TemplateEditForm,
	[SideBarTypes.templateView]: TemplateView,
	[SideBarTypes.addUrl]: URLShortenerForm,
	[SideBarTypes.bulkEditUrl]: BulkEditForm,
	[SideBarTypes.uploadUrl]: BulkUrlShortnerForm,
	[SideBarTypes.profileSetting]: ProfileSetting,
	[SideBarTypes.APIKeyCreate]: APIKeyCreate,
	[SideBarTypes.APIKeyEdit]: APIKeyEdit,
	[SideBarTypes.APIKeyCreateSuccess]: APIKeyCreateSuccess,
	[SideBarTypes.CallbackProfileFilter]: FilterModal,
	[SideBarTypes.CallbackProfileCreate]: CallbackProfileCreate,
	[SideBarTypes.CallbackLogsFilter]: CallbackLogsFilterModal,
	[SideBarTypes.StickyAgentModal]: StickyAgentModal,
	[SideBarTypes.RequestReportTemplate]: RequestReport,
	[SideBarTypes.wappReqReportForm]: WhatsappRequestReport,
	[SideBarTypes.verifiedSMSView]: verifiedSMSView,
	[SideBarTypes.wappReqReportForm]: WhatsappRequestReport,
	[SideBarTypes.FlowBuilderLogsFilter]: FlowBuilderFilterModal,
	[SideBarTypes.StickyAgentModal]: StickyAgentModal,
	[SideBarTypes.PayloadModal]: PayloadModal,
	[SideBarTypes.ViewSound]: ViewSound,
	[SideBarTypes.configurationSelectTemplate]: SelectTemplate,
	[SideBarTypes.configurationEdit]: ConfigurationEditForm,
	[SideBarTypes.RechargeSubAccount]: RechargeSubAccount,
	[SideBarTypes.GenerateReports]: GenerateReports,
	[SideBarTypes.PayloadModal]: PayloadModal,
	[SideBarTypes.SipAddUserGroupModal]: AddUserGroupModal,
	[SideBarTypes.SipAddAclModal]: AddSipAclModal,
	[SideBarTypes.EditCredentialModal]: EditCredentialModal,
	[SideBarTypes.ChangeCredentialPasswordModal]: ChangeCredentialPasswordModal,
	[SideBarTypes.RenameUserGroupModal]: RenameUserGroupModal,
	[SideBarTypes.AddEditDomainModal]: AddEditDomainModal,
	[SideBarTypes.RenameSipAclModal]: RenameSipAclModal,
	[SideBarTypes.SelectUrl]: SelectUrl,

	[SideBarTypes.VoicemailViewRecording]: VoicemailViewRecording,
	[SideBarTypes.VoicemailFilterModal]: VoicemailFilterModal,

	[SideBarTypes.WhatsappTemplatesList]: WhatsappTemplatesList,
	[SideBarTypes.createFailoverTemplates]: CreateFailoverTemplates,
	[SideBarTypes.EmailTemplates]: EmailTemplates,
	[SideBarTypes.VoiceTemplates]: VoiceTemplates,
	[SideBarTypes.SmsTemplates]: SmsTemplates,
	[SideBarTypes.NewConfiguration]: NewConfiguration,
	[SideBarTypes.SpeechLogsFilterModal]: SpeechLogsFilterModal,
	[SideBarTypes.NewIpConfiguration]: NewIpConfiguration,
	[SideBarTypes.EditIpConfiguration]: EditIpConfiguration,
	[SideBarTypes.ViewApiConfiguration]: ViewApiKey,
	[SideBarTypes.LowBalanceAlertConfig]: LowBalanceAlertConfig,
	[SideBarTypes.ReportAlertConfig]: ReportAlertConfig,
	[SideBarTypes.BillingAlertConfig]: BillingAlertConfig,
	[SideBarTypes.AddEditIpConfig]: AddEditIpConfig,
	[SideBarTypes.EmailRequestReportForm] : EmailRequestReport,
	[SideBarTypes.EditExpiryModal] : EditExpiryModal
};

const RootSideBar: React.FC = () => {
	const sideBarType = useSelector(getSideBarType);
	const isOpen = useSelector(getIsOpen);
	const Component = sideBarType && SideBars[sideBarType];
	if (!isOpen && !Component) {
		document.body.removeAttribute('style');
		return null;
	}

	return <Component />;
};

export default RootSideBar;
